import { createClient } from '@supabase/supabase-js';

// Plain supabase-js client for public data queries (no SSR cookie handling needed)
export const supabasePublic = createClient(
  process.env.NEXT_PUBLIC_SUPABASE_URL!,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
);
